import React from 'react';
import './Footer.css';
import { Reveal } from './motion/Motion';
import logoImg from '../assets/images/logo.png';

const Footer = () => {
  return (
    <footer className="site-footer">
      {/* Linha de água: separa o rodapé da última seção sem recorrer às ondas
          SVG que davam o ar datado ao layout anterior. */}
      <div className="footer-glow" aria-hidden="true" />

      <div className="container footer-inner">
        <Reveal from="up" className="footer-brand">
          <img
            src={logoImg}
            alt="iPoolCare"
            className="footer-logo"
            width={300}
            height={76}
          />
          <p className="footer-tagline">De olho na piscina, cuidando de você.</p>
        </Reveal>

        <div className="footer-divider" />

        <p className="footer-copy">
          &copy; {new Date().getFullYear()} iPoolCare. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
